import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
    Divider,
    Drawer,
    List,
    ListItemButton,
    ListItemText,
    Link,
    styled,
} from '@mui/material'
import { useUIContext } from '../../context/ui'
import CloseIcon from '@mui/icons-material/Close'
import { DrawerCloseButton } from '../../styles/appbar'
import { Colors } from '../../styles/theme'

const MiddleDivider = styled((props) => (
    <Divider variant="middle" {...props} />
))``

export default function AppDrawer() {
    const { drawerOpen, setDrawerOpen } = useUIContext()

    // ADDED: Function to close drawer
    const handleClose = () => setDrawerOpen(false)

    return (
        <>
            {drawerOpen && (
                <DrawerCloseButton onClick={handleClose}>
                    <CloseIcon
                        sx={{
                            fontSize: '2.5rem',
                            color: Colors.primary,
                        }}
                    />
                </DrawerCloseButton>
            )}
            <Drawer
                open={drawerOpen}
                onClose={handleClose} // ADDED: Enables click-outside-to-close
                // ADDED: Anchor for proper mobile behavior
                anchor="left"
            >
                <List>
                    <ListItemButton>
                        <ListItemText>
                            {' '}
                            <Link
                                href="/"
                                color={Colors.secondary}
                                underline="none"
                                aria-label="Go to main information page"
                                onClick={handleClose}
                            >
                                Home
                            </Link>
                        </ListItemText>
                    </ListItemButton>

                    <MiddleDivider />
                    <ListItemButton>
                        <ListItemText>
                            {' '}
                            <Link
                                href="/calc"
                                color={Colors.secondary}
                                underline="none"
                                aria-label="Visit Fence Material Estimator App"
                                onClick={handleClose}
                            >
                                Fence Materials Estimator
                            </Link>
                        </ListItemText>
                    </ListItemButton>
                    <MiddleDivider />
                    <ListItemButton>
                        <ListItemText>
                            {' '}
                            <Link
                                component={RouterLink}
                                to="/"
                                color={Colors.secondary}
                                underline="none"
                                aria-label="Visit Products section"
                                onClick={handleClose}
                            >
                                Products
                            </Link>
                        </ListItemText>
                    </ListItemButton>
                    <MiddleDivider />
                    <ListItemButton>
                        <ListItemText>
                            {' '}
                            <Link
                                component={RouterLink}
                                to="/cart"
                                color={Colors.secondary}
                                underline="none"
                                aria-label="Visit your cart items"
                                onClick={handleClose}
                            >
                                Cart Review
                            </Link>
                        </ListItemText>
                    </ListItemButton>
                    <MiddleDivider />
                    <ListItemButton>
                        <ListItemText>
                            <Link
                                href="/privacy"
                                color={Colors.secondary}
                                underline="none"
                                aria-label="Read about Privacy Policy"
                                onClick={handleClose}
                            >
                                Privacy &amp; Policy
                            </Link>
                        </ListItemText>
                    </ListItemButton>
                    <MiddleDivider />
                    <ListItemButton>
                        <ListItemText>
                            <Link
                                component={RouterLink}
                                to="/info/terms_conditions"
                                color={Colors.secondary}
                                underline="none"
                                aria-label="Learn about Terms and Conditions"
                                onClick={handleClose}
                            >
                                Terms &amp; Conditions
                            </Link>
                        </ListItemText>
                    </ListItemButton>
                    <MiddleDivider />
                    <ListItemButton>
                        <ListItemText>
                            <Link
                                component={RouterLink}
                                to="/info/shipping"
                                color={Colors.secondary}
                                underline="none"
                                aria-label="Learn about Shipping Policies"
                                onClick={handleClose}
                            >
                                Shipping Policy
                            </Link>
                        </ListItemText>
                    </ListItemButton>
                    <MiddleDivider />
                    <ListItemButton>
                        <ListItemText>
                            <Link
                                component={RouterLink}
                                to="/info/return_policy"
                                color={Colors.secondary}
                                underline="none"
                                aria-label="Learn about Return Policy"
                                onClick={handleClose}
                            >
                                Return Policy
                            </Link>
                        </ListItemText>
                    </ListItemButton>
                    <MiddleDivider />
                    <ListItemButton>
                        <ListItemText>
                            {' '}
                            <Link
                                component={RouterLink}
                                to="/info/card_security"
                                color={Colors.secondary}
                                underline="none"
                                aria-label="Learn about Terms and Conditions"
                                onClick={handleClose}
                            >
                                Cardholder Security Policy
                            </Link>
                        </ListItemText>
                    </ListItemButton>
                    <MiddleDivider />
                </List>
            </Drawer>
        </>
    )
}
